/* BebeLux — Sticky Add-to-Cart (alle Breiten). Bild, Angebot und Button folgen dem Hauptproduktformular. */
(function () {
  function init() {
    var bar = document.querySelector('.bb-sticky-atc');
    if (!bar || bar._init) return;
    bar._init = true;

    function productForm() {
      return document.getElementById(bar.getAttribute('data-bb-product-form'));
    }
    function mainSubmit() {
      var form = productForm();
      return form && form.querySelector('.product-form__submit[name="add"]');
    }
    function mainAnchor() {
      var form = productForm();
      return form && (form.querySelector('.product-form__buttons') || mainSubmit());
    }

    var anchor = mainAnchor();
    if (!anchor) { bar.remove(); return; }

    var btn = bar.querySelector('[data-bb-sticky-add]');
    var img = bar.querySelector('.bb-sticky-atc__img');
    var offer = bar.querySelector('[data-bb-sticky-offer]');
    var variantData = bar.querySelector('[data-bb-sticky-variants]');
    var images = {};
    try { images = JSON.parse(variantData.textContent); } catch (e) { /* Keep the server-rendered image. */ }

    function syncImage() {
      var form = productForm();
      var input = form && form.querySelector('input[name="id"]');
      var selected = input && images[input.value];
      if (!img || !selected || !selected.src) return;
      if (img.getAttribute('src') !== selected.src) img.setAttribute('src', selected.src);
      img.alt = selected.alt;
    }

    // Gewähltes Angebot aus dem bb-offer-picker spiegeln: "Kaufe 2 · 180,00 €"
    function syncOffer() {
      if (!offer) return;
      var checked = document.querySelector('bb-offer-picker input[name^="bb-offer"]:checked');
      var box = checked && checked.closest('.bbo-offer');
      if (!box) {
        // Ohne Mengenangebote: Preis der gewaehlten Variante zeigen
        var form = productForm();
        var input = form && form.querySelector('input[name="id"]');
        var v = input && images[input.value];
        if (v && v.price && offer.textContent !== v.price) offer.textContent = v.price;
        return;
      }
      var title = box.querySelector('.bbo-offer__title');
      var price = box.querySelector('[data-price-now]');
      var text = (title ? title.textContent.trim() : '') + (price ? ' · ' + price.textContent.trim() : '');
      if (text && offer.textContent !== text) offer.textContent = text;
    }

    function syncButton() {
      var submit = mainSubmit();
      if (!btn) return;
      var disabled = !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      if (btn.disabled !== disabled) btn.disabled = disabled;
    }
    function syncAll() { syncImage(); syncOffer(); syncButton(); }

    if (btn) btn.addEventListener('click', function () {
      var submit = mainSubmit();
      if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
      submit.click();
    });

    // global.js dispatches this event after assigning the selected variant ID.
    // Delegation also survives an asynchronously replaced product form.
    document.addEventListener('change', function (event) {
      var form = productForm();
      if (event.target && event.target.name && event.target.name.indexOf('bb-offer') === 0) { syncOffer(); return; }
      if (form && form.contains(event.target) && event.target.name === 'id') syncAll();
    });
    var section = bar.closest('section');
    if (section) new MutationObserver(syncAll).observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'hidden'] });

    function setShown(on) {
      if (bar.classList.contains('is-visible') === on) return;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
      document.documentElement.classList.toggle('bb-sticky-atc-on', on);
    }

    var raf = 0;
    function update() {
      raf = 0;
      if (!anchor.isConnected) anchor = mainAnchor();
      if (!anchor) { setShown(false); return; }
      setShown(anchor.getBoundingClientRect().bottom <= 0);
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(update); }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('pageshow', syncAll);
    syncAll();
    update();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
